/* lib/uiHelpers.js — чистые презентационные хелперы (без данных/сети).
   Перенесено из мок-слоя при его снятии. ХЕНДОФФ: 1:1 во frontend/src/lib. */

// FC%-цветокод позиции меню (P2-04). Если передан target_food_cost_pct — пороги
// ПРИВЯЗАНЫ к цели меню (ok ≤ цель / warn до цель+2пп / bad выше), чтобы шкала меню
// не дрейфовала от FoodCostBadge и была честной «vs цель». Без target — прежняя
// фиксированная шкала <25 ok / 25–30 warn / ≥30 bad (обратная совместимость).
export function menuFcTone(v, target) {
  if (v == null || isNaN(v)) return 'neutral';
  const t = (target == null || isNaN(target)) ? null : Number(target);
  if (t != null && t > 0) {
    if (v <= t) return 'ok';
    if (v <= t + 2) return 'warn';
    return 'bad';
  }
  if (v < 25) return 'ok';
  if (v < 30) return 'warn';
  return 'bad';
}
